import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Button, Divider, Grid, Modal, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { carData, paymentStatusMapping } from '../../../../utils/constants/carData';
import { BidHistory } from '../BidHistory';
// import { BidHistory } from "@himanshusarma123/frontend_common";
import CarDetails from '../CarDetails';
import { mainContainer } from '../VehicleInfoSidebarSx';
import theme from '../../../../theme';
import SaleInformation from '../SaleInformation';
import {
  useLazyGetAuctionHistoryAdminQuery,
  useLazyGetAuctionHistoryAgentQuery,
  useLazyGetAuctionHistorySellerQuery,
  useLazyGetBidHistoryQuery,
  useLazyGetLiveAuctionVehiclesQuery,
} from '../../../../toolkit/liveAuction/liveAuctionApi';
import { useLazyGetAgentDetailsQuery } from '../../../../toolkit/carDetails/carDetailsApi';
import {
  convertFromUTCToGivenTimezone,
  convertUtcStringFormat,
  formatTimeFromSeconds,
} from '../../../../utils/methods/dateTime';
import { useCountdownTimer } from '../../../../customHooks/useCountdownTimer';
import { useDispatch, useSelector } from 'react-redux';
import { reducerPaths } from '../../../../app/reducerPaths';
import {
  Bidding_Through,
  exportAuctionTimeInMins,
  localAuction,
  localAuctionTimeInMins,
} from '../../../../utils/constants/auction';
import { getImagesHandler } from '../../../../utils/methods/setSellMyCarForms';
import { parsedVehicle } from '../../../../utils/methods/parsedVehicleForCarData';
import { useLocation } from 'react-router-dom';
import { routes } from '../../../../utils/constants/routes';
import { useLazyGetVehicleQuery } from '../../../../toolkit/vehicle/vehicleApi';
import { setAlertDialog } from '../../../../toolkit/alertDialog/alertDialogSlice';
import { useLiveAuctionSocketEvents } from './customHooks/useLiveAuctionSocketEvents';
import { resetLiveAuctionSlice } from '../../../../toolkit/liveAuction/liveAuctionSlice';
import ReservePriceMetCard from '@common/pages/Dashboard/components/LiveAuction/components/ReservePriceOrNearReserverPriceCard';
import { BidHistoryPopup } from '../BidHistoryPopup';
import { useTranslation } from 'react-i18next';
import TimeLeft from '../../components/TimeLeft';
import CarDetailSkeleton from '../CarDetailsSkeleton';
import auctionLogo from "../../../../components/assets/auction.svg";
import PreviousAuctionsButton from '../../../../components/ui/PreviousAuctionsButton';
import { isVehicleSold } from '../../../../utils/methods/generalVehicleMethods';
import CostBreakdownSeller from '../../../../components/custom/CostBreakdownSection/CostBreakdownSeller';
import { useLazyDownloadBOSQuery } from '../../../../toolkit/payments/paymentsApi';
import { USER_ROLES } from '../../../../utils/constants/userRoles';
import { vehicleSoldStageUIMapping } from '../../../../utils/constants/vehicle';
import { getCommaFormattedNumber } from '../../../../utils/methods/stringMethods';


// const TimeLeftInAuction = ({
//   data
// }) => {

//   const { t } = useTranslation("timeLeft");

//   const { countDown, isInitialised } = useCountdownTimer({
//     seconds: Math.floor(data?.seconds || 0)
//   });

//   return (
//     <Box
//       sx={{
//         backgroundColor: theme.palette.primary.main,
//         color: theme.palette.text.secondary,
//         textAlign: "center",
//         borderRadius: "0.75rem", // 12px
//         paddingTop: "1rem",      // 16px
//         paddingBottom: "1rem",
//         paddingLeft: "0.5rem",   // 8px
//         paddingRight: "0.5rem",
//       }}
//     >
//       {(countDown?.hours > 0 || countDown?.minutes > 0 || countDown?.seconds > 0) && isInitialised ? <Typography fontWeight={600} fontSize="1.1rem"
//         sx={{
//           color: theme.palette.text.secondary
//         }}
//       >
//         {t("Time Left In Auction")}
//       </Typography> : null}
//       <Typography fontWeight={500} fontSize="1rem" marginTop="0.25rem">
//         {!isInitialised ? (
//           <span style={{ fontWeight: 700, color: theme.palette.text.secondary }}>
//             Loading...
//           </span>
//         ) : countDown?.hours > 0 || countDown?.minutes > 0 || countDown?.seconds > 0 ? (
//           <>
//             <span style={{ fontWeight: 700, color: theme.palette.text.secondary }}>
//               {`${countDown?.hours < 10 ? `0${countDown?.hours}` : countDown?.hours}`}
//             </span>{" "}{t("hours")}{" "}
//             <span style={{ fontWeight: 500, color: theme.palette.text.secondary }}>
//               {`${countDown?.minutes < 10 ? `0${countDown?.minutes}` : countDown?.minutes}`}
//             </span>{" "}{t("mins")}{" "}
//             <span style={{ fontWeight: 600, color: theme.palette.text.secondary }}>
//               {`${countDown?.seconds < 10 ? `0${countDown?.seconds}` : countDown?.seconds}`}
//             </span>{" "}{t("sec")}
//           </>
//         ) : (
//           <span style={{ fontWeight: 700, color: theme.palette.text.secondary }}>
//             {t("Time's up")}
//           </span>
//         )}

//       </Typography>
//     </Box>
//   );
// };

const AuctionWonTag = ({ 
  highestBid,
  selectedCar
}) => {
  const auth = useSelector((store) => store[reducerPaths.auth]);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: '1.25rem', // Rounded corners for the main card
        padding: '1.5rem', // Inner padding for the main card
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem', // Space between the two inner boxes
        width: '100%', // Take full width of parent
        boxShadow: '0rem 0.25rem 0.625rem rgba(0, 0, 0, 0.1)', // Subtle shadow
      }}
    >
      {/* Car Sold Section */}
      <Box
        sx={{
          backgroundColor: 'rgba(43, 210, 76, 0.1)', // Light green background (10% opacity of primary.green)
          border: `0.0625rem solid ${theme.palette.primary.green}`, // Green border
          borderRadius: '0.625rem', // Rounded corners
          paddingTop: '1.5rem',
          paddingBottom: '1.5rem',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body1" // Use body1 variant for text
          sx={{
            textAlign: "center",
            color: theme.palette.primary.green, // Green text color
            fontWeight: 600, // Make text bold
            fontSize: '1.125rem', // Custom font size for this text
          }}
        >
          {highestBid?.Dealer_Id === auth?.user_id
            ? 'You won the auction'
            : `The ${vehicleSoldStageUIMapping[selectedCar?.sold_stage]} was won by: ${highestBid?.dealer_type?.toLowerCase?.()?.includes?.(USER_ROLES.dealer) ? 
              `Dealer ID ${highestBid?.Dealer_Id}` : 
              `Buyer ID ${highestBid?.Dealer_Id}`} at $${getCommaFormattedNumber(selectedCar?.winning_amount)}`}
        </Typography>
      </Box>
    </Box>
  );
};

// Main Car Detail Page component
const LiveAuctionCarDetail = (
  {
    // selectedCar = {},
    // setSelectedCar
  }
) => {
  const isMobile = useMediaQuery('(max-width:1300px)');

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.includes?.(routes.liveAuction) ? 
    location?.pathname?.split?.(`${routes.liveAuction}/`)?.[1] : 
    location?.pathname?.includes?.(routes.myOrders) ?
    location?.pathname?.split?.(`${routes.myOrders}/`)?.[1] : 
    location?.pathname?.includes?.(routes.allOrders) ?
    location?.pathname?.split?.(`${routes.allOrders}/`)?.[1] : "";

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useState variables start...
  const [selectedCar, setSelectedCar] = React.useState(null);
  const [viewAuctionBidHistory, setViewAuctionBidHistory] = React.useState(false);
  const [isPaymentCompleted, setIsPaymentCompleted] = React.useState(false);
  // useState variables end...

  // useSelector start...
  const liveAuction = useSelector((store) => store[reducerPaths.liveAuction]); // useSelector start...
  const auth = useSelector((store) => store[reducerPaths.auth]);
  // useSelector end...

  const liveAuctionDateTime = selectedCar?.Live_Auction_DateTime
    ? convertFromUTCToGivenTimezone({
        dateStr: convertUtcStringFormat(selectedCar?.Live_Auction_DateTime),
        timezone: auth?.timezone,
      })
    : new Date();

  const liveAuctionEndDate = new Date(liveAuctionDateTime);
  liveAuctionEndDate.setMinutes(
    liveAuctionEndDate.getMinutes() +
      (selectedCar?.auction_type === localAuction ? localAuctionTimeInMins : exportAuctionTimeInMins)
  );

  const liveAuctionRemainingSeconds = Math.floor(
    liveAuctionEndDate.getTime() - new Date().getTime() > 1000
      ? (liveAuctionEndDate.getTime() - new Date().getTime()) / 1000
      : 0
  );

  const highestBid = (liveAuction?.bidHistory?.data || [])
    ?.map?.((bid) => {
      return {
        ...bid,
        Bid_Amount: parseInt(bid?.Bid_Amount),
      };
    })
    ?.sort?.((bidA, bidB) => {
      const bidAAmount = parseInt(bidA?.Bid_Amount);
      const bidBAmount = parseInt(bidB?.Bid_Amount);

      if (bidAAmount < bidBAmount) {
        return 1;
      }
      if (bidAAmount > bidBAmount) {
        return -1;
      }
      return 0;
    })?.[0];

  // Handlers start...
  // const parsedVehicle = (selectedCar) => {
  //   const images = [];
  //   const carImages = getImagesHandler({
  //     data: {
  //       vehicle: selectedCar
  //     }
  //   });

  //   for (let i = 0; i < Object.entries(carImages?.images)?.length; i++) {
  //     for (let j = 0; j < Object.entries(carImages?.images)?.[i]?.[1]?.length; j++) {
  //       if (Object.entries(carImages?.images)?.[i]?.[1]?.[j]) {
  //         images.push(Object.entries(carImages?.images)?.[i]?.[1]?.[j])
  //       }
  //     }
  //   }

  //   return {
  //     ...selectedCar,
  //     images
  //   };
  // }

  const onNewBidHandler = async () => {
    await getBidHistoryApiHandler({
      vehicleId: selectedCar?.Vehicle_Id,
    });

    await getAuctionHistoryApiHandler({
      Vehicle_Id: selectedCar?.Vehicle_Id,
    });
  };

  const onPaymentSuccessHandler = () => {
    setIsPaymentCompleted(true);
  };
  // Handlers end...

  // custom hook calls start...
  const [getVehicleApiHandler, getVehicleApiData] = useLazyGetVehicleQuery();
  const [getAgentDetailsApiHandler, getAgentDetailsApiData] = useLazyGetAgentDetailsQuery();
  const [getLiveAuctionVehicleApiHandler, getLiveAuctionVehicleApiData] = useLazyGetLiveAuctionVehiclesQuery();
  const [getBidHistoryApiHandler, getBidHistoryApiData] = useLazyGetBidHistoryQuery();
  const [getAuctionHistorySellerApiHandler, getAuctionHistorySellerApiData] = useLazyGetAuctionHistorySellerQuery();
  const [getAuctionHistoryAgentApiHandler, getAuctionHistoryAgentApiData] = useLazyGetAuctionHistoryAgentQuery();
  const [getAuctionHistoryAdminApiHandler, getAuctionHistoryAdminApiData] = useLazyGetAuctionHistoryAdminQuery();
  const [downloadBOSApiHandler, downloadBOSApiData] = useLazyDownloadBOSQuery();

  let getAuctionHistoryApiHandler = auth?.user_role === USER_ROLES.seller ?
    getAuctionHistorySellerApiHandler :
    auth?.user_role === USER_ROLES.agent ?
    getAuctionHistoryAgentApiHandler :
    auth?.user_role === USER_ROLES.admin ?
    getAuctionHistoryAdminApiHandler :
    null;

  let getAuctionHistoryApiData = auth?.user_role === USER_ROLES.seller ?
    getAuctionHistorySellerApiData :
    auth?.user_role === USER_ROLES.agent ?
    getAuctionHistoryAgentApiData :
    auth?.user_role === USER_ROLES.admin ?
    getAuctionHistoryAdminApiData :
    null;

  const { countDown, isInitialised } = useCountdownTimer({
    seconds: liveAuctionRemainingSeconds,
  });

  useLiveAuctionSocketEvents({
    Vehicle_Id: selectedCar?.Vehicle_Id,
    onNewBidHandler,
  });
  // custom hook calls end...

  // useState variables start...
  // useState variables end...

  // useEffect start...
  // React.useEffect(() => {
  //   getLiveAuctionVehicleApiHandler({
  //     endpoint: `/seller/vehicle/${selectedCar?.Vehicle_Id}`
  //   });
  // }, [selectedCar]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getVehicleApiHandler({
          Vehicle_Id,
        });

        console.log(res, `getVehicleApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message: res?.error?.data?.error || res?.error?.data?.message || `Some error occured!`,
            })
          );
        } else {
          setSelectedCar(res?.data?.vehicle);
          setIsPaymentCompleted(paymentStatusMapping[res?.data?.payment_status]);
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (isPaymentCompleted) {
      if (Vehicle_Id) {
        const intervalId = setTimeout(() => {
          (async () => {
            const res = await getVehicleApiHandler({
              Vehicle_Id,
            });

            if (isVehicleSold({ car: res?.data?.vehicle })) {
              clearInterval(intervalId);
            }

            if (res?.error) {
              dispatch(
                setAlertDialog({
                  open: true,
                  title: `Error`,
                  message: res?.error?.data?.error || res?.error?.data?.message || `Some error occured!`,
                })
              );
            } else {
              setSelectedCar(res?.data?.vehicle);
              setIsPaymentCompleted(paymentStatusMapping[res?.data?.payment_status]);
            }
          })();
        }, 5000);
      }
    }
  }, [
    Vehicle_Id, 
    isPaymentCompleted
  ]);

  React.useEffect(() => {
    if (countDown?.hours === 0 && countDown?.minutes === 0 && countDown?.seconds === 0) {
      (async () => {
        const res = await getVehicleApiHandler({
          Vehicle_Id,
        });

        setSelectedCar(res?.data?.vehicle);
      })();
    }
  }, [countDown]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getAgentDetailsApiHandler({
          vehicleId: Vehicle_Id,
        });

        console.log(res, `getAgentDetailsApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message: res?.error?.data?.error || res?.error?.data?.message || `Some error occured!`,
            })
          );
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!selectedCar?.Vehicle_Id) {
      return;
    }

    (async () => {
      await getBidHistoryApiHandler({
        vehicleId: selectedCar?.Vehicle_Id,
      });
    })();
  }, [selectedCar?.Vehicle_Id]);

  React.useEffect(() => {
    return () => {
      dispatch(resetLiveAuctionSlice());
    };
  }, []);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      await getAuctionHistoryApiHandler({
        Vehicle_Id,
      });
    })();
  }, [Vehicle_Id]);
  // useEffect end...

  console.log(getBidHistoryApiData, 'getLiveAuctionVehicleApiData');

  return (
    <Grid container spacing={2} sx={mainContainer}>
      {/* Left sidebar with buttons */}
      {getVehicleApiData?.isFetching || !selectedCar ? (
        <CarDetailSkeleton />
      ) : (
        <>
          <Grid size={{ xl: 2.8 - 0.2, lg: 4 - 0.2, md: 12, sm: 12, xs: 12 }}>
            <Box display={'flex'} flexDirection="column" gap={2}>
              {!isPaymentCompleted && !isVehicleSold({ car: selectedCar }) ? <TimeLeft
                data={{
                  seconds: liveAuctionRemainingSeconds,
                }}
              /> : (
                isVehicleSold({ car: selectedCar }) && isPaymentCompleted && auth?.user_role === USER_ROLES.seller ? (
                  <Button
                    sx={{
                      width: "100%",
                      background: theme.palette.primary.main,
                      color: theme.palette.background.paper,
                      "&:disabled": {
                        background: "transparent",
                        border: `1px solid ${theme.palette.border.disabled}`
                      }
                    }}
                    onClick={async () => {
                      const res = await downloadBOSApiHandler({
                        Vehicle_Id
                      });

                      console.log(res, "downloadBOSApiHandler")

                      const filename = "Bill_Of_Sale.pdf";
                      
                      const blob = res?.data;

                      // 2. Create a temporary URL for the Blob
                      const url = URL.createObjectURL(blob);

                      // 3. Create a temporary <a> element to trigger the download
                      const link = document.createElement('a');
                      link.href = url;
                      // Set the suggested filename for the download
                      link.download = filename;

                      // 4. Programmatically click the link to start the download
                      document.body.appendChild(link);
                      link.click();

                      // 5. Clean up the temporary URL and link element
                      document.body.removeChild(link);
                      URL.revokeObjectURL(url);

                      // onClickCompleteProcessingHandler();
                      // setIsPaymentModalOpen(true);
                    }}
                    disabled={!isPaymentCompleted || downloadBOSApiData?.isLoading}
                    // disabled={getCurrencyConversionApiData?.isFetching}
                    // disabled={!currency?.conversionRates}
                  >
                    Download Bill Of Sale
                  </Button>
                ) : null
              )}

              {getVehicleApiData?.isFetching ? null : 
                isVehicleSold({
                  car: selectedCar
                }) && liveAuction?.bidHistory?.data?.length > 0 ? (
                <AuctionWonTag
                  selectedCar={selectedCar}
                  highestBid={
                    (liveAuction?.bidHistory?.data || [])
                      ?.map?.((bid) => {
                        return {
                          ...bid,
                          Bid_Amount: parseInt(bid?.Bid_Amount),
                        };
                      })
                      ?.sort?.((bidA, bidB) => {
                        const bidAAmount = parseInt(bidA?.Bid_Amount);
                        const bidBAmount = parseInt(bidB?.Bid_Amount);

                        if (bidAAmount < bidBAmount) {
                          return 1;
                        }
                        if (bidAAmount > bidBAmount) {
                          return -1;
                        }
                        return 0;
                      })?.[0]
                  }
                />
              ) : parseInt(selectedCar?.Reserve_Price) <= highestBid?.Bid_Amount ||
                parseInt(selectedCar?.Reserve_Price) <= highestBid?.Bid_Amount + 500 ? (
                <ReservePriceMetCard car={selectedCar} highestBid={highestBid} />
              ) : null}

              {/* {getAuctionHistoryApiData?.data?.auctions?.length > 0 ? <Button
            sx={{
              background: theme.palette.primary.main,
              color: theme.palette.background.paper,
              fontSize: "1.25rem",
              textTransform: "capitalize"
            }}
            onClick={() => {
              setViewAuctionBidHistory(true);
            }}
          >
            Bid history ({getAuctionHistoryApiData?.data?.auctions?.length})
          </Button> : null} */}

              {getAuctionHistoryApiData?.data?.auctions?.length > 0 ? (
                <Box>
                  <PreviousAuctionsButton 
                    onClick={() => {
                      setViewAuctionBidHistory(true);
                    }}
                  />
                  {/* <Button
                    variant="contained"
                    fullWidth
                    startIcon={<img src={auctionLogo} />}
                    sx={sidebarButton}
                    onClick={() => {
                      setViewAuctionBidHistory(true);
                    }}
                  >
                    Previous Auctions
                  </Button> */}
                </Box>
              ) : null}

              <BidHistory
                selectedCar={selectedCar}
                bids={getBidHistoryApiData?.data?.TopBids?.filter?.((bid) => {
                  return bid?.Bidding_Through === Bidding_Through.Auction;
                })?.map?.((bid) => {
                  return {
                    ...bid,
                    amount: bid?.Bid_Amount,
                    dealerId: bid?.Dealer_Id,
                    dateTime: bid?.Bid_Date,
                  };
                })}
                isLoading={getBidHistoryApiData?.isLoading}
              />

              {!isVehicleSold({ car: selectedCar }) ? <CostBreakdownSeller 
                car={selectedCar}
              /> : null}
              
              <SaleInformation
                data={{
                  ...(getAgentDetailsApiData?.data?.[0] || {}),
                  address: selectedCar?.Location,
                  date: selectedCar?.Live_Auction_DateTime,
                }}
                car={selectedCar}
              />
            </Box>
          </Grid>
          <Divider orientation={'vertical'} flexItem />
          {/* Right Section - 70% */}
          <Grid size={{ xl: 9.2 - 0.2, lg: 8 - 0.2, md: 12, sm: 12, xs: 12 }}>
            <CarDetails car={parsedVehicle(selectedCar)} showEdit />
          </Grid>
        </>
      )}
      {/* Main content area */}

      {viewAuctionBidHistory ? (
        <Modal
          open={true}
          onClose={() => {
            setViewAuctionBidHistory(false);
          }}
        >
          <BidHistoryPopup
            selectedCar={selectedCar}
            auctionHistory={getAuctionHistoryApiData?.data?.auctions?.map?.((auction) => {
              return {
                ...auction,
                bids: auction?.OldBidsHistory?.map?.((bid) => {
                  return {
                    ...bid,
                    amount: bid?.Bid_Amount,
                    dateTime: bid?.Bid_Date,
                  };
                }),
              };
            })}
            handleClose={() => {
              setViewAuctionBidHistory(false);
            }}
          />
        </Modal>
      ) : null}
    </Grid>
  );
};

export { LiveAuctionCarDetail };
